import React, {
    Component
} from 'react';
import {
    connect
} from 'react-redux';
import common from './../../common';
import config from './../../config';
import {
    getOutTeamArray,
} from "../../helper";
import {
    getWildCardStatus,
    getBoosterStatus,
} from "../../helper-common";
import {
    getUserSpecificFixtures,
} from './../../actions/ManageTeamActions';
import {
    setBoosterPopupState,
} from './../../actions/FormationActions';
import Modal from '../Modal'


class BoosterBtn extends Component {

    constructor(props) {
        super(props)
        this.state = {
            showModal: false,
            errorObj: {
                error: 5,
                msg1: "",
                icon: ""
            }
        }
    }

    onLimitlessBoosterTap = (isLimitlessDisabled, teamData, GDID) => {
        common.customTracking('Booster - Limitless','/uclfantasy/my-team/transfers/');
        const limitlessStatus = getBoosterStatus(teamData, GDID);
        const wildCardStatus = getWildCardStatus(teamData, GDID);
        if (isLimitlessDisabled) {

            if (limitlessStatus === config.limitlessBoosterStatus["notStarted"]) {
                // show pop up when match day has not yet started
                this.props.setBoosterPopupState({ showBoosterPopup: true, type: config.booster["matchdayNotStartedLimitLess"], case: 'limitless' });
            } else {
                // show toast when used already
                // check if used in current
                if (wildCardStatus == config.wildCardStatus["usedInCurrentTemp"] || wildCardStatus == config.wildCardStatus["usedInCurrent"]) {
                    //toast msg to show you have used wild card already cant use limitless at same time 

                    if (limitlessStatus === config.limitlessBoosterStatus["usedInBefore"]) {
                        this.setState({

                            showModal: true,
                            errorObj: {
                                error: 5,
                                msg1: this.props.trans.limitLesserror2 ? this.props.trans.limitLesserror2 : "toast msg to show that you have already used your limitless",
                                icon: "icon-ucl-limitless"
                            }
                        })
                    } else {
                        this.setState({

                            showModal: true,
                            errorObj: {
                                error: 5,
                                msg1: this.props.trans.limitLesserror1 ? this.props.trans.limitLesserror1 : "toast msg to show you have used wild card already cant use limitless at same time ",
                                icon: "icon-ucl-limitless"
                            }
                        })
                    }

                } else {
                    //toast msg to show that you have already used your limitless
                    this.setState({

                        showModal: true,
                        errorObj: {
                            error: 5,
                            msg1: this.props.trans.limitLesserror2 ? this.props.trans.limitLesserror2 : "toast msg to show that you have already used your limitless",
                            icon: "icon-ucl-limitless"
                        }
                    })
                }
            }
        } else {
            this.props.setBoosterPopupState({ showBoosterPopup: true, type: config.booster["limitless"] });
        }

    };
    onWildCardBoosterTap = (isWildCardDisabled, teamData, GDID) => {
        common.customTracking('Booster - Wildcard', '/uclfantasy/my-team/transfers/');
        const wildCardStatus = getWildCardStatus(teamData, GDID);
        const limitlessStatus = getBoosterStatus(teamData, GDID);

        if (isWildCardDisabled) {
            //show tool tip
            if (wildCardStatus === config.wildCardStatus["notStarted"]) {
                // show pop up when match day has not yet started
                this.props.setBoosterPopupState({ showBoosterPopup: true, type: config.booster["matchdayNotStartedWildcard"], case: 'wildcard' });
            } else {
                // show toast when used already
                // check if used in current
                if (limitlessStatus == config.limitlessBoosterStatus["usedInCurrentTemp"] || limitlessStatus == config.limitlessBoosterStatus["usedInCurrent"]) {
                    //toast msg to show you have used limit card already cant use wild at same time 
                    //check if wild card already used before
                    if (wildCardStatus === config.wildCardStatus["usedInBefore"]) {
                        this.setState({

                            showModal: true,
                            errorObj: {
                                error: 5,
                                msg1: this.props.trans.wildCarderror2 ? this.props.trans.wildCarderror2 : "toast msg to show you have used wild card",
                                icon: "icon-ucl-wildcard"
                            }
                        })
                    } else {
                        this.setState({

                            showModal: true,
                            errorObj: {
                                error: 5,
                                msg1: this.props.trans.wildCarderror1 ? this.props.trans.wildCarderror1 : "toast msg to show you have used limit card already cant use wild at same time",
                                icon: "icon-ucl-wildcard"
                            }
                        })
                    }

                } else {
                    //toast msg to show that you have already used your wild card
                    this.setState({

                        showModal: true,
                        errorObj: {
                            error: 5,
                            msg1: this.props.trans.wildCarderror2 ? this.props.trans.wildCarderror2 : "toast msg to show that you have already used your wild card",
                            icon: "icon-ucl-wildcard"
                        }
                    })
                }
            }
        } else {
            this.props.setBoosterPopupState({ showBoosterPopup: true, type: config.booster["wildcard"] });
        }


    };

    closePopUp = () => {
        this.setState({
            showModal: false,
            errorObj: {
                error: 5,
                msg1: "",
                icon: ""
            }
        })
    }


    render() {
        const {
            teamData,
            userSpecificFixtures,
            currentActiveFixture,
            trans
        } = this.props;
        const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
        const {
            GDID
        } = currentFixture;
        const wildCardStatus = getWildCardStatus(teamData, GDID);
        const limitlessStatus = getBoosterStatus(teamData, GDID);
        const isWildCardSelected = (wildCardStatus === config.wildCardStatus["usedInCurrent"] || wildCardStatus === config.wildCardStatus["usedInCurrentTemp"]);
        const isLimitlessSelected = (limitlessStatus === config.limitlessBoosterStatus["usedInCurrent"] || limitlessStatus === config.limitlessBoosterStatus["usedInCurrentTemp"]);
        const isWildCardDisabled = isLimitlessSelected || !(wildCardStatus === config.wildCardStatus["startedAndNotUsed"]);
        const isLimitlessDisabled = isWildCardSelected || !(limitlessStatus === config.limitlessBoosterStatus["startedAndNotUsed"]);
        const wildCardBoosterClass = common.makeClasses({
            'si-new-comp': true,
            'si-booster': true,
            'si-disabled': isWildCardDisabled,
            'si-selected': isWildCardSelected,
        });
        const limitlessBoosterClass = common.makeClasses({
            'si-new-comp': true,
            'si-booster': true,
            'si-disabled': isLimitlessDisabled,
            'si-selected': isLimitlessSelected,
        });
        return <React.Fragment >
            <div className={ wildCardBoosterClass } onClick={ () => this.onWildCardBoosterTap(isWildCardDisabled, teamData, GDID) } >
                <i className="icon-ucl-wildcard" />
                <span> {
                    (wildCardStatus === config.wildCardStatus["usedInBefore"]) ? trans.played : trans.wildcard
                } </span> </div>
            <div className={ limitlessBoosterClass } onClick={ () => this.onLimitlessBoosterTap(isLimitlessDisabled, teamData, GDID) } >
                < i className="icon-ucl-limitless" />
                <span> {
                    (limitlessStatus === config.limitlessBoosterStatus["usedInBefore"]) ? trans.played : trans.limitless
                } </span> </div>
            { this.state.showModal ? <Modal error={ this.state.errorObj } resetError={ this.closePopUp } /> : null }
        </React.Fragment>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        teamData: state.formationData.teamData,
        userSpecificFixtures: state.formationData.userSpecificFixtures,
        currentActiveFixture: state.formationData.currentActiveFixture,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getOutTeamArray: (teamData, oldTeamData) => dispatch(getOutTeamArray(teamData, oldTeamData)),
        getUserSpecificFixtures: () => dispatch(getUserSpecificFixtures()),
        setBoosterPopupState: (obj) => dispatch(setBoosterPopupState(obj)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(BoosterBtn);


// WEBPACK FOOTER //
// ./src/components/onboarding/BoosterBtn.js